import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  /** メインラベル */
  label: string;
  /** アイコン（オプション） */
  icon?: React.ReactNode;
  /** サブテキスト（secondaryカラーで表示） */
  sub?: string;
  /** 背景色 */
  bgcolor?: string;
  /** 枠線の色 */
  borderColor?: string;
  /** テキストカラー */
  color?: string;
  /** 追加sx */
  sx?: object;
};

/**
 * フローステップ用ブロックコンポーネント
 *
 * 角丸四角形で表示する。色とラベルで各ステップを表現する。
 */
const WorkflowChevronArrow: React.FC<Props> = ({
  label,
  icon,
  sub,
  bgcolor = '#1a3a5c',
  borderColor = '#2c5282',
  color = '#fff',
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: 1,
        borderColor,
        borderRadius: 2,
        bgcolor,
        minHeight: 56,
        px: 2,
        py: 1,
        ...sx,
      }}
    >
      <Stack alignItems="center" spacing={0.25}>
        {icon && <Box sx={{ color, display: 'flex' }}>{icon}</Box>}
        <Typography
          variant="caption"
          fontWeight={600}
          sx={{ lineHeight: 1.3, color, textAlign: 'center', whiteSpace: 'nowrap' }}
        >
          {label}
        </Typography>
        {sub && (
          <Typography
            variant="caption"
            sx={{ lineHeight: 1.2, color, opacity: 0.75, textAlign: 'center' }}
          >
            {sub}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default WorkflowChevronArrow;
